import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';

import {
  VISIT_COMMENT_COLLAPSED_ROWS,
  VISIT_COMMENT_PF as PF,
} from '@app/components/VisitsHistory/components/VisitComment/data';
import { useVisitComment } from '@app/components/VisitsHistory/components/VisitComment/hooks';

import type { FC } from 'react';

import './VisitComment.scss';

const { Paragraph, Text } = Typography;

interface VisitCommentProps {
  comment: string;
}

export const VisitComment: FC<VisitCommentProps> = ({ comment }) => {
  const { isExpanded, isTruncated, toggleHandler, ellipsisHandler } =
    useVisitComment();

  return (
    <div className={PF}>
      <Text className={`${PF}__label`}>Комментарий:</Text>
      <Paragraph
        className={`${PF}__text`}
        data-testid="visit-comment"
        ellipsis={{
          rows: VISIT_COMMENT_COLLAPSED_ROWS,
          expanded: isExpanded,
          onEllipsis: ellipsisHandler,
        }}
      >
        {comment}
      </Paragraph>
      {isTruncated && (
        <Button
          className={`${PF}__toggle`}
          data-testid="visit-comment-toggle"
          icon={isExpanded ? <UpOutlined /> : <DownOutlined />}
          iconPosition="end"
          onClick={toggleHandler}
        >
          {isExpanded ? 'Свернуть' : 'Показать полностью'}
        </Button>
      )}
    </div>
  );
};
